export class LoginModel {
  userName!: string;
  password!: string;
}

export enum ResUserLoginRedirectEnum {
  Dashboard = 'Dashboard',
  ReservationsList = 'ReservationsList',
  ReservationsFloor = 'ReservationsFloor',
  Orders = 'Orders',
  OrdersList = 'OrdersList',
  Takeaway = 'Takeaway',
  Profile = 'Profile'
}
